import { dataPage } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPage = /*#__PURE__*/createIcon(dataPage)
export default IconPage
